export default "__VITE_ASSET__y8Iu$b6z__"